import paymentFailureIcon from '@assets/images/payment-failed-icon.svg';
import { ContactPoint, StoreKey } from '@common/constans';
import { StorageType } from '@common/enum';
import { IGResponse } from '@common/models';
import { IContactPoint } from '@common/models/CMS';
import Contact from '@components/general/Contact';
import Button from '@components/general/form/Button';
import { CreateStep } from '@components/Stepper';
import { IAppState } from '@misc/State';
import { CONTACT_POINT, useApolloQuery } from '@service/graphql';
import Storage from '@service/Storage';
import Translate from "@service/Translate";
import { clearStoreForSearch } from '@utilize/Util';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router";

interface IPaymentFailureProps { }

const PaymentFailure: FC<IPaymentFailureProps> = (props) => {
    const tr = Translate.tr;
    const { push } = useHistory();
    const query = new URLSearchParams(useLocation().search);
    const { data } = useApolloQuery<IGResponse<IContactPoint[]>>(CONTACT_POINT);
    const { searchMode } = useSelector((state: IAppState) => ({ searchMode: state.searchMode }));
    const traceNumber = query.get("traceNumber");
    const ib = data?.contactPoint.find(c => c.code?.code === ContactPoint.IBE);
    const charIndex = ib?.phone?.indexOf("(") || -1;
    const phone = charIndex > -1 ? ib?.phone?.slice(0, charIndex)?.replace(/ /g, "")?.trim() : ib?.phone?.replace(/ /g, "")?.trim();

    const onSearchAgain = () => {
        clearStoreForSearch(searchMode, true, CreateStep.SelectFlight);
        push(Storage.get(StoreKey.SearchHistory, StorageType.Session));
    }

    return (
        <div className="payment-failure">
            <div className="container">
                <div className="row">
                    <div className="col-1-1">
                        <img className="payment-failed-img" src={paymentFailureIcon} alt="Payment Failed Icon" />
                    </div>
                    <div className="col-1-1">
                        <div className="payment-failed-desc">{tr("payment_msg_failed")}</div>
                    </div>
                    <div className="col-1-1">
                        <div className="payment-failed-reverse-money">{tr("payment_msg_reverse_failed")}</div>
                    </div>
                    <div className="col-1-1">
                        <div className="payment-failed-reverse-money">{tr("trace_number")}: {traceNumber}</div>
                    </div>
                    <div className="col-1-1">
                        <Button
                            variant="contained"
                            color="danger"
                            text={tr("research")}
                            width="200px"
                            onClick={onSearchAgain}
                        />
                    </div>
                    <div className="col-1-1">
                        <div className="contact-info">{tr("msg_call_support_info")}</div>
                    </div>
                    <div className="col-1-1 flex justify-center">
                        <Contact
                            email={ib?.email || ""}
                            emailText={ib?.email || ""}
                            emailSubject={`Payment Failed ${traceNumber}`}
                            phone={phone || ""}
                            phoneText={ib?.phone || ""}
                            orientation="horizontal"
                            haveIcon
                        />
                    </div>
                </div>
            </div>

        </div>
    )
}
export default PaymentFailure;